const BRAND_TOKEN = window.BottleNexusJaws.BRAND_TOKEN;
const opts = {
  layout: "basic",
  behavior: "sidebar",
  showInput: true,
  donation: "no_donation",
  buttonText: window.BottleNexusJaws.ctaText,
  buttonTextColor: "#FFFFFF",
  buttonBackground: "#242424",
  buttonFontSize: "15px",
  buttonRadius: "0",
  cartButtonRadius: "0",
  cartCheckoutBackgroundColor: "#242424",
  cartCheckoutTextColor: "#FFFFFF",
};

function BottleNexusJawsInit() {
  function ensureSDK(cb) {
    if (window.BottleNexus && window.BottleNexus.init) return cb();
    var s = document.createElement("script");
    s.src = "https://buybutton.bottlenexus.com/buybutton.min.js";
    s.async = true;
    s.onload = cb;
    document.head.appendChild(s);
  }

  function initBNX() {
    if (!window.BottleNexus) return;
    BottleNexus.init().setConfig({ token: BRAND_TOKEN, options: opts });

    if (
      !customElements.get("bottle-nexus-submit-wrapper") &&
      document.querySelector("bottle-nexus-submit-wrapper")
    ) {
      customElements.define(
        "bottle-nexus-submit-wrapper",
        BottleNexusSubmitWrapper
      );
    }
  }

  function wireNativeCartButtons() {
    let nativeCartButtons = document.querySelectorAll("a.cart-link");
    if (nativeCartButtons) {
      nativeCartButtons.forEach((button) => {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          document
            .querySelector(
              "[data-style='bottle-nexus-toggle'] [data-component='toggle']"
            )
            .click();
        });
      });
    }
  }

  ensureSDK(initBNX);

  document.addEventListener("DOMContentLoaded", wireNativeCartButtons);
}

BottleNexusJawsInit();

class BottleNexusSubmitWrapper extends HTMLElement {
  constructor() {
    super();

    this.bnx = this;
    this.form = this.closest("form[data-product-form]");

    this.wireAddToCartButton();
  }

  wireAddToCartButton() {
    let qtyInput = this.form.querySelector(
      '.number-input-wrapper input[id="Quantity"]'
    );
    let addBtn = this.form.querySelector('button[data-role="bnx-add"]');
    let bottleNexusIDs = JSON.parse(
      this.form.querySelector("[data-bottle-nexus-json]").textContent
    );

    // Add to Cart
    if (addBtn) {
      addBtn.addEventListener("click", function () {
        console.log("button clicked");
        event.preventDefault(); //trying to override Shopify form submission

        let bnxVariantId;
        if (bottleNexusIDs.product.bottle_nexus_id) {
          bnxVariantId = bottleNexusIDs.product.bottle_nexus_id;
        } else {
          let currentShopifyVariantId = this.form.querySelector(
            'input[type="radio"][data-variant-id]:checked'
          ).dataset.variantId;

          bnxVariantId = bottleNexusIDs.variants.find(
            (variant) => variant.id == currentShopifyVariantId
          ).bottle_nexus_id;
        }

        if (!bnxVariantId) {
          alert("Error - Please select valid variant.");
          return;
        }
        let qty = qtyInput ? parseInt(qtyInput.value || "1", 10) : 1;

        addBtn.disabled = true;
        var oldText = addBtn.textContent;
        addBtn.textContent = "Adding…";

        window.bottlenexus
          .addToCart(bnxVariantId, BRAND_TOKEN, {
            quantity: qty,
            recurrence: "one-time",
            donation: "no_donation",
          })
          .finally(function () {
            addBtn.textContent = "Added!";
            setTimeout(function () {
              addBtn.textContent = oldText;
              addBtn.disabled = false;
            }, 1200);
          });
      });
    }
  }
}
